import {Modal} from 'bootstrap';
import {AddPortfolio} from './admin/add-portfolio.js';
import {Item} from './admin/item';
export let general = (function(){
    window.loading = function(){
        document.querySelector('#loader').style.display = 'block';
        document.querySelector('#loader').classList = 'loading';
    }
    window.loaded = function loaded(){
        document.querySelector('#loader').classList = 'loaded';
        setTimeout(function(){
            document.querySelector('#loader').style.display = 'none';
        }, 500)
    }

    /// custom file input
    function setFileInputEvent(e){
        this.closest('.form-file').querySelector('.form-file-text').innerText = e.target.files[0].name;
    }
    document.querySelectorAll('.form-file-input').forEach(function(fileInput){
        fileInput.addEventListener('change', setFileInputEvent);
    });
    let pageFormContainer = document.querySelector('#page-form-container');
    if(pageFormContainer){
        document.querySelector('#page-form-container').addEventListener('DOMSubtreeModified', function(){
            document.querySelectorAll('.form-file-input').forEach(function(fileInput){
                fileInput.addEventListener('change', setFileInputEvent);
            });
        });
    }

    // xl modal
    function xlModal(){
        document.querySelector('#page-modal').querySelector('#modal-dialog').className = 'modal-dialog modal-dialog-centered modal-xl';
    }

    // regular modal
    function regularModal(){
        document.querySelector('#page-modal').querySelector('#modal-dialog').className = 'modal-dialog modal-dialog-centered';
    }

    // xs modal
    function xsModal(){
        document.querySelector('#page-modal').querySelector('#modal-dialog').className = 'modal-dialog modal-dialog-centered modal-xs';
    }

    // modal alert
    try {
        const alertModal = new Modal(document.querySelector('#page-modal-alert'));
        alertModal.show();
    }catch(error){}
        
    function initializeDeleteButtons(){
        let deleteButtons = document.querySelectorAll('.delete-button');
        if(deleteButtons){
            deleteButtons.forEach(function(trigger){
                trigger.addEventListener('click', setDeleteButtonEvent)
            });
        }
    }

    try {
        initializeDeleteButtons();
    } catch (error) {}

    function setDeleteButtonEvent(e){
        e.preventDefault();
        let form = `
            <form action="/save-form" class="" method="post" enctype="multipart/form-data">
                <div class="modal-body px-4">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group d-none">
                                <input type="hidden" name="id" value="${this.dataset.id}">
                            </div>
                        </div>
                        <div class="col-md-12 text-center">
                            <span>Are you sure you want to delete this item? This action is irreversible</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer py-2">
                    <a href="#" class="btn btn-secondary rounded-pill" data-dismiss="modal"><i class="fas fa-times"></i> Cancel</a>
                    <button type="submit" class="btn btn-danger submit-form rounded-pill"><i class="fas fa-trash"></i> Proceed</button>
                </div>
            </div>
        `;
        let item = new Item(this);
        item.setForm(form);
        item.submitCallback = function(data){
            this.trigger.closest('.item').remove();
            this.modal.hide();
            window.loaded();
        }
    }

    // change evvent in items-container
    try {
        document.querySelector('.items-container').addEventListener('DOMSubtreeModified', function(){
            initializeDeleteButtons();
            initializeEditButtons();
        });
    } catch (error) {
        
    }

    // edit button
    function initializeEditButtons(){
        document.querySelectorAll('.edit-button').forEach(function(editButton){
            editButton.addEventListener('click', editButtonEvent);
        });
    }
    try {
        initializeEditButtons();
    } catch (error) {}

    function editButtonEvent(e){
        e.preventDefault();
        let item = new Item(this);
        item.fetchData().then(data => {
            let form = `
                <form action="/save-form" class="" method="post" enctype="multipart/form-data">
                    <div class="modal-body px-4">
                        <div class="row">
                            <div class="col-md-12">
                                <label class="form-label">Title</label>
                                <input type="hidden" name="id" value="${data.id}">
                                <input name="title" type="text" value="${(data.title) ? data.title : ''}" class="form-control">
                            </div>
                            <div class="col-md-12 pt-3">
                                <label class="form-label">Image</label>
                                <div class="form-file" style="font-size:0.75em;">
                                    <input name="image" type="file" class="form-file-input" id="customFile">
                                        <label class="form-file-label" for="customFile">
                                        <span class="form-file-text">${(data.image) ? data.image : 'Choose file...'}</span>
                                        <span class="form-file-button">Browse</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-12 pt-3">
                                <label class="form-label">Category</label>
                                <select name="portfolio_category_id" class="form-select" required>
                                    ${window.portfolioCategories.map(function(category){
                                        return `<option value="${category.id}" ${(data.portfolio_category_id == category.id) ? 'selected' : ''}>${category.name}</option>`;
                                    })}
                                </select>
                            </div>
                            <div class="col-md-12 pt-3">
                                <label class="form-label">Description</label>
                                <textarea name="description" class="form-control" rows="3">${(data.description) ? data.description : ''}</textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer py-2">
                        <a href="#" class="btn btn-danger rounded-pill" data-dismiss="modal"><i class="fas fa-times"></i> Cancel</a>
                        <button type="submit" class="btn btn-primary rounded-pill submit-form"><i class="fas fa-save"></i> Submit</button>
                    </div>
                </div>
            `;
            item.setForm(form);
            item.submitCallback = function(data){
                let image = this.trigger.closest('.item').querySelector('.thumbnail');
                image.style.backgroundImage = `url("/img/jpg/portfolio/thumbnails/${data.image}")`;
                image.querySelector('a').href = `/img/jpg/portfolio/originals/${data.image}`;
                // console.log(image);
                // image.src = image.src + 'test';
                window.lightbox.reload();
                this.modal.hide();
                window.loaded();
            }
            window.loaded();
        });
    }
    function addButtonEvent(){
        document.querySelector('#add-item').addEventListener('click', function(e){
            e.preventDefault();
            let form = `
                <form action="/save-form" class="" method="post" enctype="multipart/form-data">
                    <div class="modal-body px-4">
                        <div class="row">
                            <div class="col-md-12">
                                <label class="form-label">Title</label>
                                <input name="title" type="text" class="form-control">
                            </div>
                            <div class="col-md-12 pt-3">
                                <label class="form-label">Image</label>
                                <div class="form-file" style="font-size:0.75em;">
                                    <input name="image" type="file" class="form-file-input" id="customFile">
                                        <label class="form-file-label" for="customFile">
                                        <span class="form-file-text">Choose file...</span>
                                        <span class="form-file-button">Browse</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-12 pt-3">
                                <label class="form-label">Category</label>
                                <select name="portfolio_category_id" class="form-select" required>
                                    ${window.portfolioCategories.map(function(category){
                                        return `<option value="${category.id}">${category.name}</option>`;
                                    })}
                                </select>
                            </div>
                            <div class="col-md-12 pt-3">
                                <label class="form-label">Description</label>
                                <textarea name="description" class="form-control" rows="3"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer py-2">
                        <a href="#" class="btn btn-danger rounded-pill" data-dismiss="modal"><i class="fas fa-times"></i> Cancel</a>
                        <button type="submit" class="btn btn-primary rounded-pill submit-form"><i class="fas fa-save"></i> Submit</button>
                    </div>
                </div>
            `;
            let item = new Item(this);
            item.setForm(form);
            item.submitCallback = function(data){
                let content= `
                    <div class="card h-100 border-0 p-0">
                        <div class="card-body thumbnail" style="background-image:url('/img/jpg/portfolio/thumbnails/${data.image}');">
                            <a href="/img/jpg/portfolio/originals/${data.image}" class="glightbox">
                            </a>
                        </div>
                        <div class="card-footer bg-white">
                            <nav class="nav nav-fill">
                                <a class="nav-link edit-button" href="#" data-id="${data.id}" data-title="Edit Portfolio" data-get="/admin/portfolio/get" data-submit="/admin/portfolio/update">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil text-primary" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z"/>
                                        <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z"/>
                                    </svg>       
                                </a>
                                <a class="nav-link delete-button" href="#" data-id="${data.id}" data-title="Delete item" data-submit="/admin/portfolio/delete">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-trash text-danger" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                        <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                    </svg>     
                                </a>
                            <nav>
                        </div>
                    </div>
                `;
                let itemsContainer = document.querySelector('.items-container');
                let div = document.createElement('div');
                div.classList = 'col-lg-3 item';
                div.innerHTML = content;
                itemsContainer.appendChild(div);
                window.lightbox.reload();
                this.modal.hide();
                window.loaded();
            }
        });
    }
    try {
        addButtonEvent();
    } catch (error) {
        
    }

    // card content truncate toggle
    let cardLists = document.querySelectorAll('.card-list-body');
    cardLists.forEach(function(cardList){
        let content = cardList.querySelector('.card-list-content');
        cardList.addEventListener('mouseover', function(){
            this.style.maxHeight = `${110 + ((parseInt(content.clientHeight))-43)}px`;
        });
        cardList.addEventListener('mouseout', function(){
            this.style.maxHeight = `110px`;
        });
    });

    document.querySelectorAll('.scroll').forEach(function(scroll){
        scroll.addEventListener('click', scrollEvent);
    });

    function scrollEvent(e){
        e.preventDefault();
        const target = this.dataset.target;
        const startMain = document.querySelector(`#${target}`);
        const nav = window.getComputedStyle(document.querySelector('#top-nav-md'),null);
        console.log(nav.getPropertyValue('height'));
        window.scrollTo({
            top: startMain.getBoundingClientRect().top - (parseInt(nav.getPropertyValue('height')) - (parseInt(nav.getPropertyValue('padding-top')) * 2))
        });
    }

})();